import * as React from 'react';

import * as agui from 'arm-gui/dist/controls';
import { Utils, isAuth, NumberFormatter, domain, domainVal, i18n, DateFormatter } from 'arm-common';

class PopUpCreazioneFP extends React.Component {
    constructor(props) {
        super(props),
            this.componentName = "[PopUpCreazioneFP.jsx]"
        this.state = {
            validation: new Map()
        }
        this.inputChangeHandler = this.inputChangeHandler.bind(this);
        this.salvaOggetto = this.salvaOggetto.bind(this);
        this.showConfirmPanel = this.showConfirmPanel.bind(this);

    }

    componentDidMount() {
        console.log(this.componentName + 'componentDidMount ');
        this.setState({ validation: new Map() })
    }
    componentWillReceiveProps() {
        console.log(this.componentName + 'componentWillReceiveProps ');
        this.setState({ validation: new Map() })
    }

    salvaOggetto() {
        if (!this.validateForm()) {
            console.log('validateForm return false');
            return null;
        }
        this.props.salvaOggetto();
    }

    showConfirmPanel() {
        this.setState({ validation: new Map })
        if (this.props.modifica) {
            this.props.annullaButton();
        } else {
            this.props.showConfirmPanel();
        }
    }

    inputChangeHandler(e) {

        let id = e.target.id;
        let value = e.target.value;
        let validation = this.state.validation;
        if (validation.get(id) !== undefined && validation.get(id) !== null) {
            validation.delete(id);
        }
        this.setState({ validation: validation });

        let type = e.target.type;
        if (type === "number" && value === "") {
            value = null;
        }

        if (id === "ordVis") {
            if (value !== undefined && value !== null) {
                if (value.includes("e") || value.includes(".")) {
                    value.replace("e", "");
                    value.replace(".", "");
                }
            }
        }

        this.props.inputChangeHandler(e);

    }

    validateForm() {
        let validation = new Map();
        let required = [];
        if (this.tipoDaCreare === 'Ambito') {
            required = ['codCampo', 'valCampo']
        } else {
            required = ['nome', 'descrizione']
        }

        for (let i = 0; i < required.length; i++) {
            if (this.props.oggettoDaCreare[required[i]] === undefined || this.props.oggettoDaCreare[required[i]] === '' || this.props.oggettoDaCreare[required[i]] === null) {
                validation.set(required[i], 'valore obbligatorio');
            }
        }
        this.setState({ validation: validation });
        if (validation.size === 0) {
            return true;
        }
        return false;
    }

    render() {
        return (
            <agui.ConfirmModalOkCancelV4 show={this.props.showConfirm} >
                <agui.ConfirmModalOkCancelV4.Header testoTitle={
                    (this.tipoDaCreare === 'Ambito') ?
                        i18n('ARM_CORE_PRODUCT.SHARED.CREAZIONE_NUOVO_AMBITO', 'Creazione Nuovo Ambito ') :
                        (this.tipoDaCreare === 'Famiglia Prodotto') ?
                            this.props.modifica ?
                                i18n('ARM_CORE_PRODUCT.SHARED.MODIFICA_Di', 'Modifica di ') + this.props.tipoDaCreare + " con Id: " + this.props.oggettoDaCreare.id :
                                i18n('ARM_CORE_PRODUCT.SHARED.CREAZIONE_NUOVO', 'Creazione Nuova ') + this.props.tipoDaCreare + " per " + this.props.tipoVisualizzato + ": " + this.props.tipoDescrizione :
                            (this.tipoDaCreare !== 'Categoria') ?
                                this.props.modifica ?
                                    i18n('ARM_CORE_PRODUCT.SHARED.MODIFICA_Di', 'Modifica di ') + this.props.tipoDaCreare + " con Id: " + this.props.oggettoDaCreare.id :
                                    i18n('ARM_CORE_PRODUCT.SHARED.CREAZIONE_NUOVO', 'Creazione Nuova ') + this.props.tipoDaCreare + " per " + this.props.tipoVisualizzato + ": " + this.props.tipoDescrizione : null

                } onClose={this.showConfirmPanel} />

                <agui.ConfirmModalOkCancelV4.Body testoBody="">
                    {this.props.tipoDaCreare === "Ambito" ?
                        <div>
                            {isAuth('VIEW_CODICE_DOMINIO') &&
                                <div className="row mt-1">
                                    <div className="col col-sm-12 col-md-12 col-lg-12">
                                        <agui.ATextInputV4 id="codCampo" type="text"
                                            info={i18n('ARM_CORE_PRODUCT.PRODOTTO.INSERIRE_CODICE_INFO', 'Questo campo non accetta spazi')}
                                            value={this.state.oggettoDaCreare ? this.state.oggettoDaCreare.codCampo : null}
                                            placeholder={i18n('ARM_CORE_PRODUCT.PRODOTTO.INSERIRE_CODICE', 'inserire codice')}
                                            required={true}
                                            disabled={true}
                                            validation={this.state.validation}
                                            label={i18n('ARM_CORE_PRODUCT.SHARED.CODICE', 'Codice')}
                                            onChange={this.inputChangeHandler} />
                                    </div>
                                </div>}
                            <div className="row mt-1">
                                <div className="col col-sm-12 col-md-12 col-lg-12">
                                    <agui.ATextInputV4 id="valCampo" type="text"
                                        value={this.state.oggettoDaCreare ? this.state.oggettoDaCreare.valCampo : null}
                                        required={true}
                                        info={i18n('ARM_CORE_PRODUCT.PRODOTTO.INSERIRE_VALORE_INFO', 'Questo campo non accetta spazi')}
                                        validation={this.state.validation}
                                        label={i18n('ARM_CORE_PRODUCT.SHARED.VALORE', 'Valore')}
                                        onChange={this.inputChangeHandler} />
                                </div>
                            </div>
                            <div className="row mt-1">
                                <div className="col col-sm-12 col-md-12 col-lg-12">
                                    <agui.ATextInputV4 id="desDom" type="text"
                                        value={this.state.oggettoDaCreare ? this.state.oggettoDaCreare.desDom : null}
                                        validation={this.state.validation}
                                        required={true}
                                        maxlength={255}
                                        label={i18n('ARM_CORE_PRODUCT.SHARED.DESCRIZIONE', 'Descrizione')}
                                        onChange={this.inputChangeHandler} />
                                </div>
                            </div>
                            {isAuth('VIEW_INFO_DOMINIO') &&
                                <div className="row mt-1">
                                    <div className="col col-sm-12 col-md-12 col-lg-12">
                                        <agui.ATextInputV4 id="info" type="text"
                                            value={this.state.oggettoDaCreare ? this.state.oggettoDaCreare.info : null}
                                            validation={this.state.validation}
                                            label={i18n('ARM_CORE_PRODUCT.SHARED.INFO', 'Info')}
                                            onChange={this.inputChangeHandler} />
                                    </div>
                                </div>}
                        </div>
                        :

                        <div>
                            <div className="row mt-1">
                                <div className="col col-sm-12 col-md-12 col-lg-12">
                                    <agui.ATextInputV4 id="nome" type="text"
                                        value={this.props.oggettoDaCreare ? this.props.oggettoDaCreare.nome : null}
                                        required={true}
                                        validation={this.state.validation}
                                        label={i18n('ARM_CORE_PRODUCT.SHARED.NOME', 'Nome')}
                                        onChange={this.inputChangeHandler} />
                                    <agui.ATextInputV4 id="descrizione" type="text"
                                        value={this.props.oggettoDaCreare ? this.props.oggettoDaCreare.descrizione : null}
                                        required={true}
                                        maxlength={255}
                                        validation={this.state.validation}
                                        label={i18n('ARM_CORE_PRODUCT.SHARED.DESCRIZINE', 'Descrizione')}
                                        onChange={this.inputChangeHandler} />
                                    {/* <agui.ATextInputV4 id="sigla" type="text"
                                        value={this.props.oggettoDaCreare ? this.props.oggettoDaCreare.sigla : null}
                                        label={i18n('ARM_CORE_PRODUCT.SHARED.SINGLA', 'Sigla')}
                                        onChange={this.inputChangeHandler} /> */}
                                    <agui.ATextInputV4 id="ordVis" type="number"
                                        min="0" step="1"
                                        info={i18n('ARM_CORE_PRODUCT.SHARED.NUMERO_INTERO', 'Solo numero intero')}
                                        value={this.props.oggettoDaCreare ? this.props.oggettoDaCreare.ordVis : null}
                                        label={i18n('ARM_CORE_PRODUCT.SHARED.ORDINE', 'Ordine')}
                                        onChange={this.inputChangeHandler} />

                                    {/* {this.props.tipoDaCreare === "Famiglia Prodotto" &&
                                        <agui.ATextInputV4 id="nomeImg" type="text"
                                            value={this.props.oggettoDaCreare ? this.props.oggettoDaCreare.nomeImg : null}
                                            label={i18n('ARM_CORE_PRODUCT.SHARED.NOME_IMG', 'Nome immagine')}
                                            onChange={this.inputChangeHandler} />} */}

                                </div>
                            </div>
                        </div>}
                </agui.ConfirmModalOkCancelV4.Body >
                <agui.ConfirmModalOkCancelV4.Footer testoButtonConfirm={i18n('ARM_CORE_PRODUCT.SHARED.SALVA', 'Salva')}
                    confirmOnClick={this.salvaOggetto} onClose={this.showConfirmPanel}>
                </agui.ConfirmModalOkCancelV4.Footer>
            </agui.ConfirmModalOkCancelV4>

        )
    }
}



export default (PopUpCreazioneFP)